interface ShouldSortByEntryOrderProps {
  stops: Array<{ orderEntrySequenceNumber?: number | null }>;
  shouldKeepOrderEntrySequence: boolean;
}

/**
 * A keep-order courier's entry order is its plan, so a complete set of entry numbers outranks the
 * route numbers of a recurring-generated order. That is how a saved reorder shows when reopened.
 */
export function shouldSortByEntryOrder({
  stops,
  shouldKeepOrderEntrySequence,
}: ShouldSortByEntryOrderProps): boolean {
  return (
    shouldKeepOrderEntrySequence &&
    stops.length > 0 &&
    stops.every((stop) => stop.orderEntrySequenceNumber != null)
  );
}
